var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "component-third-auth-buttons" }, [
    _c(
      "button",
      {
        staticClass: "button button-vk",
        attrs: {
          disabled: _vm.disableVkButton,
          type: "button",
          title: "Войти через VK ID"
        },
        on: { click: _vm.handleVKIDButton }
      },
      [
        _c("img", {
          attrs: {
            src: "/img/svg/icon-vk.svg",
            alt: "",
            width: "22",
            height: "22",
            loading: "lazy"
          }
        })
      ]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "button button-alfa",
        attrs: {
          disabled: _vm.disableAlfaButton,
          type: "button",
          title: "Войти по Alfa ID"
        },
        on: { click: _vm.handleAlfaButton }
      },
      [
        _c("img", {
          attrs: {
            src: "/img/svg/icon-alfa.svg",
            alt: "",
            width: "24",
            height: "24",
            loading: "lazy"
          }
        })
      ]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "button button-yandex",
        attrs: {
          disabled: _vm.disableYandexButton,
          type: "button",
          title: "Войти с Яндекс ID"
        },
        on: { click: _vm.handleYandexButton }
      },
      [
        _c("img", {
          attrs: {
            src: "/img/svg/icon-ya.svg",
            alt: "",
            width: "24",
            height: "24",
            loading: "lazy"
          }
        })
      ]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "button button-tinkoff",
        attrs: {
          disabled: _vm.disableTinkoffButton,
          type: "button",
          title: "Войти с TBank ID"
        },
        on: { click: _vm.handleTinkoffButton }
      },
      [
        _c("img", {
          attrs: {
            src: "/img/svg/icon-tinkoff.svg",
            alt: "",
            width: "24",
            height: "24",
            loading: "lazy"
          }
        })
      ]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "button button-gazprom",
        attrs: {
          disabled: _vm.disableGazpromButton,
          type: "button",
          title: "Войти с Газпром ID"
        },
        on: { click: _vm.handleGazpromButton }
      },
      [
        _c("img", {
          attrs: {
            src: "/img/svg/icon-gazprom.svg",
            alt: "",
            width: "48",
            height: "48",
            loading: "lazy"
          }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }